import { container } from "tsyringe";
export class UseCaseSaveCustomer {
    async handle(customer) {
        const _SaveCustomer = container.resolve("iSaveCustomer");
        const savedCustomer = await _SaveCustomer.saveCustomer(customer);
        return savedCustomer;
    }
}
